import { Component, OnInit } from '@angular/core';
import { ReportPageBase } from 'src/shared/Baseclasses/report-page-base';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';

@Component({
  selector: 'daily-churn-rate-page',
  templateUrl: './daily-churn-rate-page.component.html',
  styleUrls: ['./daily-churn-rate-page.component.scss']
})

export class DailyChurnRatePageComponent extends ReportPageBase implements OnInit 
{

  constructor(private reportService: ReportService){
    super();
  }
  
  ngOnInit()
  {    
    this.reportService.announceSummarySelected(Constants.AcuitySummary);
  }

}
